<template>
  <main>
    <PageIntro
      :heading="
        'Your <span>' +
        configStrings.clubName +
        ' ' +
        configStrings.productName +
        '</span>'
      "
      :body="'<p>Your account has been created, you must now click the verification link contained within an email sent to the email address that you used during the registration.</p>'"
    />

    <v-container fluid grid-list-lg v-if="appLogin === true">
      <v-layout row wrap>
        <v-flex xs12 sm6 offset-sm3>
          <v-layout align-center justify-center column pb-2>
            <button class="button" v-on:click="appLoginTrigger">
              Login to account
            </button>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>

    <FooterShout v-if="appLogin === false" :type="'register'" />
  </main>
</template>

<script>
import PageIntro from "@/components/PageIntro";
import FooterShout from "@/components/FooterShout";

export default {
  components: {
    PageIntro,
    FooterShout,
  },
  data() {
    return {
      appLogin: false,
    };
  },
  mounted() {
    // if they are coming from the app specific login URL adapt the page accordingly
    if (this.$router.currentRoute.name === "app-post-registration-message") {
      this.appLogin = true;
    }
  },
  methods: {
    appLoginTrigger() {
      if (typeof window.android !== "undefined") {
        window.android.onRegistrationConfirmed();
      }
      if (typeof window.webkit !== "undefined") {
        window.webkit.messageHandlers.iOS.postMessage("registrationConfirmed");
      }
    },
  },
};
</script>